import { ResponseStatus } from '@/constants/response';

const STATUS_ROUTES = {
  [ResponseStatus.ACCESS_DENIED]: 'accessDenied',
  [ResponseStatus.NOT_FOUND]: 'notFound',
};

export { STATUS_ROUTES };
